/* Acumen "Design your shelf" route map (25 Sep 2026). Data comes from snippets/acumen-route-map.liquid. */
(function () {
  var root = document.querySelector('[data-arm]');
  if (!root || root.dataset.armReady) return;
  root.dataset.armReady = '1';
  var DATA = [];
  try { DATA = JSON.parse(root.querySelector('[data-arm-data]').textContent); } catch (e) { return; }
  DATA.forEach(function (p) {
    p.bk = p.b === 'lipped-braced' ? 'lipped' : p.b;
    p.combos = (p.c || '').split(',').filter(Boolean).map(function (s) { var a = s.split('-'); return { t: +a[0], d: +a[1] }; });
  });
  var here = DATA.find(function (p) { return p.h === root.dataset.current; });
  if (!here) return;
  var ALL = { Rustic: [25, 38, 50], Modern: [35, 45] };
  var DESC = {
    Rustic: { 25: '1 inch · our thinnest shelf', 38: '1.5 inch · the classic scaffold-board thickness', 50: '2 inch · chunky' },
    Modern: { 35: 'The classic scaffold-board thickness, planed smooth', 45: 'Chunky, planed smooth' }
  };
  var S = { timber: here.timber, bracket: here.bk, thick: null, depth: null };

  /* ---------- reading / writing the page's own options (BCPO) ---------- */
  function optEls(idx) { return idx < 0 ? [] : document.querySelectorAll('[name="name' + idx + '"]'); }
  function variantOpt(idx) {
    var v = document.querySelector('form[action*="/cart/add"] select[name="id"]') || document.querySelector('select[name="vopo-id"]');
    var o = v && v.options[v.selectedIndex]; if (!o) return null;
    var parts = o.textContent.split(' - ')[0].split(' / ').map(function (x) { return x.trim(); });
    return parts[idx] || null;
  }
  function readOpt(idx) {
    var els = optEls(idx); if (!els.length) return variantOpt(idx);
    if (els[0].tagName === 'SELECT') return els[0].value || variantOpt(idx);
    var c = Array.prototype.find.call(els, function (r) { return r.checked; });
    return c ? c.value : variantOpt(idx);
  }
  function setOpt(idx, value) {
    var els = optEls(idx); if (!els.length || value == null) return false;
    if (els[0].tagName === 'SELECT') {
      var s = els[0], vals = Array.prototype.map.call(s.options, function (o) { return o.value; }).filter(Boolean);
      var v = vals.indexOf(value) >= 0 ? value : nearest(vals, value);
      if (!v) return false;
      s.value = v; s.dispatchEvent(new Event('change', { bubbles: true })); return true;
    }
    var r = Array.prototype.find.call(els, function (x) { return x.value === value; });
    if (!r) return false;
    r.click(); r.dispatchEvent(new Event('change', { bubbles: true })); return true;
  }
  function nearest(vals, want) {
    var w = parseFloat(want); if (isNaN(w)) return null;
    return vals.reduce(function (a, b) { return Math.abs(parseFloat(b) - w) < Math.abs(parseFloat(a) - w) ? b : a; });
  }
  function prop(name) { return document.querySelectorAll('[name^="properties[' + name + '"]'); }
  function readProp(name) {
    var els = prop(name); if (!els.length) return null;
    if (els[0].tagName === 'SELECT' || els[0].type === 'text' || els[0].type === 'number') return els[0].value || null;
    var c = Array.prototype.find.call(els, function (r) { return r.checked; }); return c ? c.value : null;
  }
  function setProp(name, value, synonyms) {
    var els = prop(name); if (!els.length || !value) return;
    var tries = [value].concat(synonyms || []);
    if (els[0].tagName === 'SELECT') {
      var s = els[0], hit = tries.find(function (t) { return Array.prototype.some.call(s.options, function (o) { return o.value === t; }); });
      if (hit) { s.value = hit; s.dispatchEvent(new Event('change', { bubbles: true })); }
      return;
    }
    if (els[0].type === 'text' || els[0].type === 'number') { els[0].value = value; els[0].dispatchEvent(new Event('input', { bubbles: true })); els[0].dispatchEvent(new Event('change', { bubbles: true })); return; }
    var r = Array.prototype.find.call(els, function (x) { return tries.indexOf(x.value) >= 0; });
    if (r && !r.checked) { r.click(); r.dispatchEvent(new Event('change', { bubbles: true })); }
  }
  function syncFromPage() {
    var t = here.ti >= 0 ? parseInt(readOpt(here.ti), 10) : (here.combos[0] || {}).t;
    var d = here.di >= 0 ? parseInt(readOpt(here.di), 10) : (here.combos[0] || {}).d;
    if (t) S.thick = t; if (d) S.depth = d;
  }

  /* ---------- route logic ---------- */
  function pool(timber, bracket) { return DATA.filter(function (p) { return p.timber === timber && p.bk === bracket; }); }
  function combos(timber, bracket) { var out = []; pool(timber, bracket).forEach(function (p) { p.combos.forEach(function (c) { out.push({ t: c.t, d: c.d, p: p }); }); }); return out; }
  function uniqSorted(a) { return a.filter(function (x, i) { return a.indexOf(x) === i; }).sort(function (x, y) { return x - y; }); }
  function closest(list, want) { return list.reduce(function (a, b) { return Math.abs(b - want) < Math.abs(a - want) ? b : a; }); }
  function resolve(want) {
    var cs = combos(want.timber, want.bracket); if (!cs.length) return null;
    var ts = uniqSorted(cs.map(function (c) { return c.t; }));
    var t = ts.indexOf(want.thick) >= 0 ? want.thick : closest(ts, want.thick || ts[0]);
    var ds = uniqSorted(cs.filter(function (c) { return c.t === t; }).map(function (c) { return c.d; }));
    var d = ds.indexOf(want.depth) >= 0 ? want.depth : closest(ds, want.depth || ds[0]);
    var hit = cs.find(function (c) { return c.t === t && c.d === d; });
    var notes = [];
    if (want.thick && t !== want.thick) notes.push(want.thick + 'mm isn’t made in this style, so we’ve picked ' + t + 'mm.');
    if (want.depth && d !== want.depth) notes.push(want.depth + 'cm deep isn’t made in this combination, so we’ve picked ' + d + 'cm.');
    return { timber: want.timber, bracket: want.bracket, thick: t, depth: d, page: hit.p, note: notes.join(' ') };
  }
  function carryParams(r) {
    var q = new URLSearchParams();
    q.set('rm_t', r.thick); q.set('rm_d', r.depth);
    var len = here.li >= 0 ? readOpt(here.li) : null; if (len) q.set('rm_len', len);
    var ex = readProp('Cut to an exact size'), exl = readProp('Exact length');
    if (ex === 'Yes' && exl) q.set('rm_ex', exl);
    [['rm_fin', 'Wax finish'], ['rm_wall', 'Wall type'], ['rm_pos', 'Bracket position'], ['rm_col', 'Bracket colour']].forEach(function (x) { var v = readProp(x[1]); if (v) q.set(x[0], v); });
    if (r.note) q.set('rm_note', r.note);
    return q.toString();
  }
  function go(change) {
    syncFromPage();
    var want = Object.assign({}, S, change);
    var r = resolve(want); if (!r) return;
    if (r.page.h === here.h) {
      if (here.ti >= 0) setOpt(here.ti, r.thick + 'mm');
      if (here.di >= 0) setOpt(here.di, r.depth + 'cm');
      S = { timber: r.timber, bracket: r.bracket, thick: r.thick, depth: r.depth };
      showNote(r.note); render(); return;
    }
    root.classList.add('is-loading');
    var qs = carryParams(r), view = new URLSearchParams(location.search).get('view');
    if (view && /-rmpreview$/.test(view)) qs += '&view=' + (r.page.bk === 'none' ? 'shelf-without-brackets' : 'rustic-shelf-brackets') + '-rmpreview';
    window.location.href = '/products/' + r.page.h + '?' + qs;
  }

  /* ---------- rendering ---------- */
  var thEl = root.querySelector('[data-arm-thicks]'), dEl = root.querySelector('[data-arm-depths]');
  function chip(label, on, ok, cb) {
    var b = document.createElement('button'); b.type = 'button'; b.className = 'arm__chip' + (on ? ' is-on' : '') + (ok ? '' : ' is-off');
    b.textContent = label; b.setAttribute('aria-pressed', on ? 'true' : 'false');
    if (!ok) { b.setAttribute('aria-disabled', 'true'); b.title = 'Not made in this bracket style'; }
    else b.addEventListener('click', cb);
    return b;
  }
  function render() {
    root.querySelectorAll('[data-arm-timber]').forEach(function (b) { var on = b.dataset.armTimber === S.timber; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on); });
    root.querySelectorAll('[data-arm-bracket]').forEach(function (b) {
      var id = b.dataset.armBracket, ps = pool(S.timber, id), on = id === S.bracket;
      b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on); b.hidden = !ps.length;
      var f = root.querySelector('[data-arm-from="' + id + '"]');
      if (f && ps.length) f.textContent = 'from £' + Math.min.apply(null, ps.map(function (p) { return p.from; })).toFixed(0);
    });
    var cs = combos(S.timber, S.bracket), ts = uniqSorted(cs.map(function (c) { return c.t; }));
    thEl.innerHTML = '';
    (ALL[S.timber] || ts).forEach(function (t) { thEl.appendChild(chip(t + 'mm', t === S.thick, ts.indexOf(t) >= 0, function () { go({ thick: t }); })); });
    root.querySelector('[data-arm-thickdesc]').textContent = (DESC[S.timber] || {})[S.thick] || '';
    var ds = uniqSorted(cs.filter(function (c) { return c.t === S.thick; }).map(function (c) { return c.d; }));
    dEl.innerHTML = '';
    ds.forEach(function (d) { dEl.appendChild(chip(d + 'cm', d === S.depth, true, function () { go({ depth: d }); })); });
  }
  function showNote(t) { var n = root.querySelector('[data-arm-note]'); n.textContent = t || ''; n.hidden = !t; }
  root.querySelectorAll('[data-arm-timber]').forEach(function (b) { b.addEventListener('click', function () { go({ timber: b.dataset.armTimber }); }); });
  root.querySelectorAll('[data-arm-bracket]').forEach(function (b) { b.addEventListener('click', function () { go({ bracket: b.dataset.armBracket }); }); });

  /* ---------- arrival: apply carried choices once the options app has drawn ---------- */
  var q = new URLSearchParams(location.search), started = Date.now();
  function ready() { return here.li < 0 || optEls(here.li).length; }
  function arrive() {
    if (!ready() && Date.now() - started < 8000) { setTimeout(arrive, 150); return; }
    if (q.has('rm_t') && here.ti >= 0) setOpt(here.ti, q.get('rm_t') + 'mm');
    if (q.has('rm_d') && here.di >= 0) setOpt(here.di, q.get('rm_d') + 'cm');
    if (q.has('rm_len') && here.li >= 0) setOpt(here.li, q.get('rm_len'));
    setTimeout(function () {
      if (q.has('rm_ex')) { setProp('Cut to an exact size', 'Yes'); setTimeout(function () { setProp('Exact length', q.get('rm_ex')); }, 120); }
      setProp('Wax finish', q.get('rm_fin'));
      setProp('Wall type', q.get('rm_wall'));
      setProp('Bracket position', q.get('rm_pos'));
      var col = q.get('rm_col'); setProp('Bracket colour', col, col === 'Black' ? ['Matte Black'] : col === 'Matte Black' ? ['Black'] : []);
      if (q.has('rm_note')) showNote(q.get('rm_note'));
      syncFromPage(); render();
    }, 250);
  }
  /* ---------- length lives in the route map; the page's own size controls are hidden ---------- */
  var lenSel = root.querySelector('[data-arm-len]'), lenBuilt = false;
  function hideWrap(idx) { if (idx >= 0) document.documentElement.classList.add('arm-hide-' + idx); }
  function buildLength() {
    var src = optEls(here.li)[0]; if (!src || src.tagName !== 'SELECT') return false;
    if (!lenBuilt) {
      lenSel.innerHTML = '';
      Array.prototype.forEach.call(src.options, function (o) { if (!o.value) return; var n = document.createElement('option'); n.value = o.value; n.textContent = o.value; lenSel.appendChild(n); });
      lenSel.addEventListener('change', function () { setOpt(here.li, lenSel.value); });
      root.querySelector('[data-arm-lenstep]').hidden = false;
      hideWrap(here.li); hideWrap(here.di); hideWrap(here.ti);
      lenBuilt = true;
    }
    lenSel.value = src.value || lenSel.options[0].value;
    return true;
  }
  root.querySelector('[data-arm-exact]').addEventListener('click', function () {
    setProp('Cut to an exact size', 'Yes');
    setTimeout(function () {
      var ex = document.querySelector('[name^="properties[Exact length"]');
      if (ex) { ex.scrollIntoView({ behavior: 'smooth', block: 'center' }); setTimeout(function () { ex.focus(); }, 400); }
    }, 200);
  });
  (function waitLen(n) { if (!buildLength() && n < 60) setTimeout(function () { waitLen(n + 1); }, 150); })(0);
  document.addEventListener('change', function (e) {
    if (e.target && /^name\d+$/.test(e.target.name || '')) { syncFromPage(); render(); if (lenBuilt) lenSel.value = optEls(here.li)[0].value; }
  });
  syncFromPage(); render(); arrive();
})();
